module.exports = __webpack_public_path__ + "img/27_8.d39d953a.png";